import React, { useState, useRef, useEffect } from 'react';
import { Unity } from 'react-unity-webgl';
import { useUnityMessaging } from './hooks/useUnityMessaging';
import './App.css';

function App() {
  const [isUnityVisible, setIsUnityVisible] = useState(false);
  const [devicePixelRatio, setDevicePixelRatio] = useState(window.devicePixelRatio);
  const unityContainerRef = useRef(null);

  // Dynamic device pixel ratio handling
  useEffect(() => {
    const updateDevicePixelRatio = () => {
      setDevicePixelRatio(window.devicePixelRatio);
    };

    const mediaMatcher = window.matchMedia(
      `screen and (resolution: ${devicePixelRatio}dppx)`
    );

    mediaMatcher.addEventListener("change", updateDevicePixelRatio);

    return () => {
      mediaMatcher.removeEventListener("change", updateDevicePixelRatio);
    };
  }, [devicePixelRatio]);

  // Your existing Unity messaging hook
  const {
    unityProvider,
    isLoaded,
    loadingProgression,
  } = useUnityMessaging({
    loaderUrl: '/unity-build/EscapeRoom/Build/EscapeRoom.loader.js',
    dataUrl: '/unity-build/EscapeRoom/Build/EscapeRoom.data',
    frameworkUrl: '/unity-build/EscapeRoom/Build/EscapeRoom.framework.js',
    codeUrl: '/unity-build/EscapeRoom/Build/EscapeRoom.wasm',
  });

  // Your existing fullscreen and sizing logic remains the same
  const handleFullscreen = () => {
    if (unityContainerRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        unityContainerRef.current.requestFullscreen();
      }
    }
  };

  const logContainerSizeAndAspectRatio = () => {
    if (unityContainerRef.current) {
      const { width, height } = unityContainerRef.current.getBoundingClientRect();
      const aspectRatio = width / height;
      console.log('Unity Container Size:', { width, height });
      console.log('Aspect Ratio:', aspectRatio.toFixed(4));
    }
  };

  useEffect(() => {
    const updateHeight = () => {
      if (unityContainerRef.current) {
        const width = unityContainerRef.current.clientWidth;
        const height = (width * 9) / 16;
        unityContainerRef.current.style.height = `${height}px`;
      }
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);

    const handleFullscreenChange = () => {
      logContainerSizeAndAspectRatio();
    };

    const handleResize = () => {
      logContainerSizeAndAspectRatio();
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

   return (
    <div className="App">
      <header className="App-header">
        {loadingProgression < 1 && (
          <div>Loading... {Math.round(loadingProgression * 100)}%</div>
        )}

        <div className="unity-container" ref={unityContainerRef}>
          <Unity
            unityProvider={unityProvider}
            style={{ width: '100%', height: '100%' }}
            devicePixelRatio={devicePixelRatio}
            matchWidth
            matchHeight
          />
        </div>

        <div className="controls">
          <button onClick={handleFullscreen} className="fullscreen-button">
            Toggle Fullscreen
          </button>
        </div>
      </header>
    </div>
  );

}

export default App;
